import React from "react";

import {IRangeQuery} from "../../../request/IRangeQuery";
import {VendorType} from "../../../vendor/helpers/VendorType";
import {createOfferLink} from "../../helpers/create_offer_link";
import {IOfferGroupsSimplified} from "../types/IOfferGroups";
import {generateFallbackDescription} from "./description_util";

export interface ISchemaOfferDetailRating {
    description: string | null;
    id: number;
    main_image: {
        m_img_375x211: string;
    };
    name: string;
    slug: string;
    investor: string | null;
    stats: {
        rating: number;
        votes_count: number;
        ranges_price_min: number;
        ranges_price_max: number;
        properties_count_for_sale: number;
        distance_from_region: {
            center: boolean;
            region: string;
            distance: number;
        };
    } | null;
    street_name: string;
    street_number: string | null;
    construction_date_range: IRangeQuery<string>;
    vendor: {
        type: VendorType;
        slug: string;
        name: string;
    };
    region: {
        name_declension_where: string;
    };
    groups: IOfferGroupsSimplified | null;
}

interface IProps {
    offer: ISchemaOfferDetailRating;
}

export const SchemaOfferDetailRating: React.FunctionComponent<IProps> = (props) => {
    const {
        offer: {stats}
    } = props;

    const isPropertyWithPrice = !!props.offer.stats?.ranges_price_max && !!props.offer.stats?.ranges_price_min;

    if (isPropertyWithPrice && stats && Number.isFinite(stats.rating) && Number.isFinite(stats.votes_count)) {
        const url = createOfferLink(props.offer);

        const json = {
            "@context": "https://schema.org",
            "@type": "Product",
            url,
            name: props.offer.name,
            description: props.offer.description ? props.offer.description : generateFallbackDescription(props.offer),
            image: props.offer.main_image.m_img_375x211,
            brand: props.offer.vendor.name,
            aggregateRating: {
                "@type": "AggregateRating",
                bestRating: "5",
                worstRating: "1",
                ratingValue: stats.rating,
                reviewCount: stats.votes_count
            },
            offers: {
                "@type": "AggregateOffer",
                highPrice: props.offer.stats?.ranges_price_max,
                lowPrice: props.offer.stats?.ranges_price_min,
                priceCurrency: "PLN",
                offerCount: props.offer.stats?.properties_count_for_sale
            }
        };

        return <script type="application/ld+json" dangerouslySetInnerHTML={{__html: JSON.stringify(json)}} />;
    }

    return null;
};
